
export const headCellRenderer = (obj) => {

    return <div><b>{obj.label}</b></div>;
}

export const DASHBOARD_COLUMNS = [
    {
        name: "label",
        label: "Period",
        cellClassName: 'test-css',
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "gross",
        label: "Gross",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "cogs",
        label: "COGS",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "percCogs",
        label: "%",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "labor",
        label: "Labor",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "percLabor",
        label: "%",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "netIncome",
        label: "Net Income",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "intExp",
        label: "Int Exp",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "taxExp",
        label: "Tax Exp",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "deprExp",
        label: "Depr Exp",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "amrExp",
        label: "Amr Exp",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "ebidta",
        label: "EBIDTA",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    {
        name: "ebidtaPerc",
        label: "%",
        options: {
            filter: true,
            sort: true,
            customHeadLabelRender: headCellRenderer
        }
    },
    // {
    //     name: "transnum",
    //     label: "Trans #",
    //     options: {
    //         filter: true,
    //         sort: true,
    //         customHeadLabelRender: headCellRenderer
    //     }
    // },
    // {
    //     name: "avg",
    //     label: "Avg",
    //     options: {
    //         filter: true,
    //         sort: true,
    //         customHeadLabelRender: headCellRenderer
    //     }
    // }
];

// let quarterly = { DASHBOARD_COLUMNS };
// quarterly[0].label = "SUM Qtr";
// quarterly[0].name = "label";

// let ytd = { DASHBOARD_COLUMNS };
// ytd[0].label = "YTD";
// ytd[0].name = "label";
//
// let rolling12 = { ...DASHBOARD_COLUMNS };
// rolling12[0].label = "year";
// rolling12[1].name = "label"
//
// for (let obj of quarterly) {
//     obj.options.customHeadLabelRender = headCellRenderer;
// }
//
// for (let obj of ytd) {
//     obj.options.customHeadLabelRender = headCellRenderer;
// }
//
// for (let obj of rolling12) {
//     obj.options.customHeadLabelRender = headCellRenderer;
// }

// export const DASHBOARD_COLUMNS_QUARTERLY = quarterly;
// export const DASHBOARD_COLUMNS_YTD = ytd;
// export const DASHBOARD_COLUMNS_ROLLING12 = rolling12;